module.exports = __webpack_public_path__ + "static/kumadex-jlpt-n5-50-words-d5c48aa371882f627fdaaf9a90894561.png";